/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * NicePay 결제 설정 응답
 * @export
 * @interface NicePayConfigResponse
 */
export interface NicePayConfigResponse {
    /**
     * NicePay 클라이언트 ID
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'clientId': string;
    /**
     * 상품명
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'goodsName': string;
    /**
     * 결제 금액
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'amount': string;
    /**
     * 주문 ID
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'orderId': string;
    /**
     * 결제 완료 후 리다이렉트 URL
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'returnUrl': string;
    /**
     * 가맹점 사용자 ID
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'mallUserId'?: string | null;
    /**
     * 빌링키 등록 완료 후 리다이렉트 URL
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'billingReturnUrl': string;
    /**
     * 액션 URL
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'actionUrl': string;
    /**
     * 전문 생성일시
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'ediDate': string;
    /**
     * 서명 데이터
     * @type {string}
     * @memberof NicePayConfigResponse
     */
    'signData': string;
}

